import React from "react";

function Empty(props) {
  return (
    <div class="backup_empty_wrap ">
      <div class="backup_empty_wrap__inner">
        <div class="img_holder flex_center">
          <img
            src="https://www.idrivemirror.com/webapp/images/search_results.png"
            alt="search_result"
          />
        </div>
        <p>Sorry no results found!</p>
      </div>
    </div>
  );
}

export default Empty;
